// extracted by mini-css-extract-plugin
export var light_bg = "index-module--light_bg--06845";
export var linear_background = "index-module--linear_background--93f14";
export var radial_background = "index-module--radial_background--57bf4";
export var small_egg_bg = "index-module--small_egg_bg--056b0";